import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { TranslatedCopy } from '../../../intl/TranslatedCopy';

import { H2, Link } from '../../../components';
import Accordion from '~COMPONENTS/accordion/Accordion';

import OrderDetailsShipmentProduct from './OrderDetailsShipmentProduct';

import { FIELD_NA } from '../../constants';

export class OrderDetailsShipmentEventCarton extends Component {
  constructor(props) {
    super(props);
    const { receivedExpand } = this.props;
    this.state = {
      expand: receivedExpand,
      localExpand: receivedExpand
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.receivedExpand !== prevState.expand) {
      return { expand: nextProps.receivedExpand };
    }
    return null;
  }

  onClickCallback = () => {
    this.setState(prevState => ({ expand: !prevState.expand, localExpand: !prevState.localExpand }));
  };

  renderProductList = (full = false) => {
    const {
      products,
      pack: { packageDetail }
    } = this.props;

    return packageDetail.map(detail => {
      let size;
      const detailProduct = products.filter(
        product =>
          product.shipmentProductDetails.filter(shipmentDetail => {
            if (shipmentDetail.deliveryScheduleLineNumber === detail.deliveryScheduleLineNumber) {
              size = shipmentDetail.sizeDescription;
              return true;
            }
            return false;
          }).length > 0
      )[0];

      return (
        <OrderDetailsShipmentProduct
          key={`${detailProduct.productCode}_${detail.deliveryScheduleLineNumber}_${detail.shippedQuantity}`}
          product={detailProduct}
          shipped={detail.shippedQuantity}
          size={size}
          full={full}
        />
      );
    });
  };

  render() {
    const { expand, localExpand } = this.state;
    const { cartonNumber, cartonsTotal, carrierUrlAddress, trackingNumber } = this.props;
    return (
      <div className='orderDetails__shipments_carton mb1-sm'>
        <div className='orderDetails__shipments_cartonHeader p5-sm flex-container column space-between bg-white'>
          <H2>
            <TranslatedCopy id='orderstatus.cartonCurrent' values={{ current: cartonNumber, total: cartonsTotal }} />
          </H2>
          <H2>
            <TranslatedCopy id='orderstatus.trackingNumber' />
            {': '}
            {carrierUrlAddress &&
            carrierUrlAddress !== '' &&
            trackingNumber &&
            trackingNumber !== '' &&
            trackingNumber !== FIELD_NA ? (
              <Link to={carrierUrlAddress.replace('%TRACKINGNO%', trackingNumber)} external>
                {trackingNumber}
              </Link>
            ) : (
              <>{trackingNumber}</>
            )}
          </H2>
        </div>
        <div className='orderDetails__shipments_cartonBody'>
          <Accordion
            id={`${trackingNumber}_${cartonNumber}`}
            trigger={
              <div className='bg-white ml5-sm ml1-md'>
                {localExpand || expand ? (
                  <TranslatedCopy id='checkout.products.collapse' />
                ) : (
                  <TranslatedCopy id='orderstatus.viewSizeGrids' />
                )}
              </div>
            }
            open={expand}
            onClickCallback={this.onClickCallback}
          >
            <div className='orderDetails__shipments_cartonBody_full pt5-sm prl5-sm prl0-md mb-5-sm'>
              {this.renderProductList(true)}
            </div>
          </Accordion>
          {!localExpand && (
            <div
              className={classnames(
                'orderDetails__shipments_cartonBody_overview',
                'pt5-sm prl5-sm flex-container row start wrap bg-white'
              )}
            >
              {this.renderProductList()}
            </div>
          )}
        </div>
      </div>
    );
  }
}

OrderDetailsShipmentEventCarton.propTypes = {
  receivedExpand: PropTypes.bool.isRequired,
  cartonNumber: PropTypes.number.isRequired,
  cartonsTotal: PropTypes.number.isRequired,
  carrierUrlAddress: PropTypes.string.isRequired,
  trackingNumber: PropTypes.string.isRequired,
  products: PropTypes.any,
  pack: PropTypes.object
};

OrderDetailsShipmentEventCarton.defaultProps = {
  products: [],
  pack: null
};

export default OrderDetailsShipmentEventCarton;
